export const HEADERS = {
    headers: {
    'Authorization': process.env.REACT_APP_HeaderAuth,
    'Access-Control-Allow-Private-Network': process.env.REACT_APP_HeaderAccess,
    'Cors': process.env.REACT_APP_HeaderCors
        }
}
export const WEB_API_SERVER = process.env.REACT_APP_WebApiServer;